import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Icon from 'components/Icon'
import CloseIcon from 'icons/CloseIcon'
import styles from './Dialog.css'

const Dialog = ({ className, style, title, onClose, children, hidden }) => {
  if (hidden) {
    return null
  }
  return (
    <div className={[styles.dialog, className].join(' ')}>
      <div className={styles.glass} onClick={onClose} />
      <section className={styles.chrome} style={style}>
        <header>
          <h3>
            <a onClick={onClose}>
              <Icon icon={CloseIcon} />
            </a>
            {title ? <FormattedMessage id={title} /> : null}
          </h3>
        </header>
        <section className={styles.content}>{children}</section>
      </section>
    </div>
  )
}

Dialog.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string
  ]).isRequired,
  onClose: PropTypes.func.isRequired
}

export default Dialog
